import { LayoutServiceData, HTMLLink } from "@sitecore-jss/sitecore-jss-nextjs";
import Head from "next/head";
import { ReactNode } from "react";
import { VisuallyHidden } from "@repo/ui/visually-hidden";
import { ConstantsProvider } from "@/constants/constants-provider";
import { getPageMeta } from "./utils";
import "./sitecore-global.css";

interface LayoutProps {
  layoutData: LayoutServiceData;
  headLinks: HTMLLink[];
  children: ReactNode;
}

const Layout = ({
  layoutData,
  headLinks,
  children,
}: LayoutProps): JSX.Element => {
  const { title, description } = getPageMeta(layoutData);
  return (
    <>
      <Head>
        <title>{title}</title>
        {description && <meta name="description" content={description} />}
        {headLinks.map((headLink) => (
          <link rel={headLink.rel} key={headLink.href} href={headLink.href} />
        ))}
        <ConstantsProvider />
      </Head>
      {children}
      {title && (
        <VisuallyHidden>
          <h1>{title}</h1>
          {description && <p>{description}</p>}
        </VisuallyHidden>
      )}
    </>
  );
};

export default Layout;
